export default defineNuxtRouteMiddleware((to, from) => {
    const isDirectEntry = useState('isDirectEntry', () => false)
    isDirectEntry.value = !from?.name
  })
  